import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { useNavigation } from 'react-day-picker';
import { useLoaderData } from 'react-router-dom';
import CheckoutFrom from './CheckoutFrom';
import Loading from '../../../Home/Share/Loading/Loading';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
const Payment = () => {
    const bookings = useLoaderData();
    // const navigation = useNavigation();
    const { bookName, resalePrice, booking_date } = bookings;
    // if (navigation.state === 'loading') {
    //     return <Loading></Loading>
    // }
    return (
        <div>
            <h1 className='text-3xl'>Payment For : {bookName} book</h1>
            <p className='text-xl'> Paying :$ <strong>{resalePrice}</strong> the date is   {booking_date} .</p>
            <div className='w-96 my-12'>
                <Elements stripe={stripePromise}>
                    <CheckoutFrom
                        bookings={bookings}
                    />
                </Elements>
            </div>
        </div>
    );
};

export default Payment;